"use client";

import React from "react";
import Image from "next/image";

export default function StickyWhatsapp() {
  const phoneNumber = "919211367800";
  const message = "Hi, I need some help regarding treatment options";

  return (
    <a
      href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 xl:bottom-10 right-3  z-[1000] hover:scale-110 transition-transform duration-200"
      aria-label="Chat on WhatsApp"
    >
      <div className="group flex items-center gap-2">
        <span className="font-roboto bg-white text-[15px] border border-[#91FFBA] text-black px-4 py-2 rounded shadow-md whitespace-nowrap opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
        Talk to us
        </span>
        <div className="bg-[#EDFFF3] hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300">
          <Image
            src="/images/WhatsApp_icon.png"
            alt="WhatsApp"
            width={40}
            height={40}
          />
        </div>
      </div>
    </a>
  );
}


